import { version } from '../version'
import { resolveSessionId } from './deviceIdentity'

// Em dev local o CI não substituiu o placeholder.
export function resolveAppVersion(raw: string = version): string {
  return !raw || raw.startsWith('@@') ? 'dev' : raw
}

export function readNetworkContext(
  nav: any = typeof navigator !== 'undefined' ? navigator : undefined,
) {
  const conn = nav?.connection
  return {
    online: nav ? nav.onLine : undefined,
    netType: conn?.effectiveType ?? undefined, // '4g' | '3g' | '2g' | 'slow-2g' (Chrome/Android)
  }
}

export function buildEventContext() {
  return {
    appVersion: resolveAppVersion(),
    // GUID da sessão do navegador (window.name): o que antes era o deviceId.
    sessionId: resolveSessionId(
      typeof window !== 'undefined' ? window.name : undefined,
    ),
    ...readNetworkContext(),
  }
}
